import { useState } from 'react';
import { fetcher } from '../helpers/fetcher';
import { apiLinks } from '../config/configApiLinks';
import { useAuth } from './useAuth';

export const useFindProduct = () => {
    const { authState } = useAuth();
    const [productData, setProductData] = useState(null);
    const [resNotFound, setResNotFound] = useState(false);

    const findProductByBarcode = async (inBarcode) => {
        try {
            const findedProduct = await fetcher(apiLinks.findByBarcode, 'POST',
                { barcode: inBarcode },
                true,
                authState.user.token
            );
            if (findedProduct && findedProduct.categoryAllowed !== false) {
                setProductData(findedProduct);
                setResNotFound(false);
            } else {
                setProductData(null);
                setResNotFound(true);
            }
        } catch (error) {
            setProductData(null);
            setResNotFound(true);
        }
    };

    const findProductById = async (productId) => {
        try {
            const findedProduct = await fetcher(
                `${apiLinks.findProductById}/${productId}`,
                'GET',
                null,
                true,
                authState.user.token
            );
            if (findedProduct && findedProduct.categoryAllowed !== false) {
                setProductData(findedProduct);
                setResNotFound(false);
                return findedProduct;
            }
            setProductData(null);
            setResNotFound(true);
            return null;
        } catch (error) {
            setProductData(null);
            setResNotFound(true);
            return null;
        }
    };

    return {
        productData,
        setProductData,
        findProductByBarcode,
        findProductById,
        resNotFound,
        setResNotFound,
    };
};
